import CreateUpdateModule from './CreateUpdate';
export default CreateUpdateModule;
